import React, {useContext } from 'react';
import {  MetricsFilterTitle as ChartTitle, MetricsFilterDroppable, LimitMessage  } from '../styles/containerComponents.styles'
import styled, { css } from 'styled-components'
import { fontSizeM, ColorGreyDark, ColorGreyLight, fontSizeS, BoxShadow, bezier, colorTeal, colorPurple, colorTealLight, colorPurpleLight } from '../styles/sharedStyles';
import { Droppable } from 'react-beautiful-dnd';
import { ChartContext } from '../context/ChartContext';
import { ReactComponent as ChevronIcon } from '../assets/icons/chevronIcon.svg'
import { ReactComponent as DropdownIcon } from '../assets/icons/dropdownArrow.svg'
import FilterList from './FilterList';
import QuestionCounterElement from './QuestionCounter';
import BarChart from './BarChart';
import _ from 'lodash'
import answerStrings from '../data/answerString';
import answerValues from '../data/answers';
import answers from '../data/answers.json'

const ChartContainer = styled.div`
    display: grid;
    grid-template-rows: 5rem 80rem;
    grid-gap: 1rem;
    height: 100%;
    position: relative;
    padding-left: 1rem;
    padding-right: 1rem;
    box-shadow: ${BoxShadow};
`

const ToggleIconContainer = styled.div`
    
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    height: 5rem;
    width: 5rem;
    top: -.1rem;
    left: -5rem;
    background: ${ColorGreyLight};
    cursor: pointer;

    border-radius: 3px 0px 0px 3px;
    border-top: 1px solid rgba(51,51,51,.02);
    border-bottom: 1px solid rgba(51,51,51,.02);
    border-left: 1px solid rgba(51,51,51,.02);
    border-right: 1px solid rgba(255,255,255,1);
    
    .toggle-icon {

        height: 2rem;
        width: 2rem;
        fill: ${ColorGreyDark};
        transform: rotate(180deg);
        transition: transform .5s .5s ${bezier};

        ${props => props.hideFilters && css`
                    transform: rotate(0deg);
        `}
        cursor: pointer;
    }
`

const ChartContainers = styled.div`
    display: grid;
    grid-template-rows: repeat(5, 16rem);
`

const ChartDropContainer = styled.div`
    font-size: ${fontSizeM};
    color: ${ColorGreyDark};

    display: grid;
    grid-template-columns: 3fr 7fr;
    grid-gap: 1rem;
`

const ChartDropTitle = styled.div`
    display: flex;
    align-items: center;
`

const ChartDropField = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => props.align || 'flex-start'};
    justify-content: flex-end;
    padding-bottom: .5rem;
    position: relative;
`

const AppliedFilters = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: ${fontSizeS};
    align-self: stretch;
    padding-right: 1rem;

    position: relative;

    .dropdown-container {
        display: flex;
        align-items: center;
        

        &__text {
            cursor: pointer;
            display: flex;
            align-items: center;
        }

        .dropdown-icon{
            fill: ${ColorGreyDark};
            margin-left: .3rem;
            height: .5rem;
            transition: transform .5s ${bezier};
            

            ${props => props.toggle ? css`
                transform: translateY(.2rem)  rotate(0deg);
            ` : css`
                transform: translateY(.2rem)  rotate(180deg);
            `}

        }

        .filters-list {
            position: absolute;
            width: 500px;
            ${'' /* max-width: 500px; */}
            max-height: 400px;
            overflow-y: scroll;
            top: 4rem;
            right: 1rem;
            box-shadow: ${BoxShadow};
            transition: height .5s ${bezier};
            color: ${ColorGreyDark};
            background: #fff;
            z-index: 10;

            padding: 1.5rem 3rem;

            display: flex;
            flex-direction: column;

            ${props => props.toggle ? css`
                visibility: visible;
                height: auto;
            ` : css`
                visibility: hidden;
                height: 0rem;
            `}
        }
    }
`

const ChartElement = styled.div`
    display: grid;
    height: 16rem;
    grid-template-rows: 5rem 11rem;
`

const Chart = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ChartElements = () => {

    const { borderDroppable, 
            metricQuestions,  setMetricQuestions,
            chartQuestions, setChartQuestions,  
            filterQuestions, 
            hideFilters, setHideFilters,
            filteredDataset, path,
            filtersAppliedToggle, setFiltersAppliedToggle } = useContext(ChartContext)
    
   

    const totalData = path === "hrds" ? answers.hrds : answers.les
    const respondentType = path === "hrds" ? "Human Rights Defender" : "Legal Experts"

    const handleChartTitleClick = q => {
        const newFilterQuestions = chartQuestions.filter(d => d.question !== q.question)
        const newMetricQuestions = _.uniqBy([...metricQuestions, q].sort((a,b) => +a.qid - +b.qid), "qid")

        console.log(newMetricQuestions);
        
        setChartQuestions(newFilterQuestions)
        setMetricQuestions(newMetricQuestions)
    }
    
    const getChartData = (dataset) => {
        const formattedData = chartQuestions.map(el => {

            const calculateData = dataset.map(d => d[el.qid])
                
            const values = answerValues[el.qid].answers
            const searchStrings = answerStrings[el.qid].strings
            const matchNumbers = searchStrings.map(el => calculateData.map(d => d.toLowerCase().includes(el.toLowerCase())).filter(d => d === true).length)
            const totalLength = matchNumbers.reduce((acc, curr) => acc +curr, 0)  
            
            const sublength = searchStrings.map(string => calculateData.filter(d => d.toLowerCase().includes(string.toLowerCase())).length/totalLength)
            const dataArray = _.zipObject(values, sublength)
    
            return dataArray
        })
        return formattedData
    }
    let chartDataDisplay, chartDataCompare

    if((chartQuestions[0] ? respondentType === chartQuestions[0].respondent : true)){
        chartDataDisplay = getChartData(filteredDataset)
        chartDataCompare = getChartData(totalData)
    }
    
    return ( 
        <ChartContainer
        >
            <ToggleIconContainer
                hideFilters={hideFilters}
                onClick={() => {
                    setHideFilters(prevstate => !prevstate)
                    setFiltersAppliedToggle(false)
                }}
                data-tut="chart-toggle"
            >
                <ChevronIcon
                    className="toggle-icon "  
                />
            </ToggleIconContainer>
            <ChartDropContainer>
                <ChartDropTitle>
                    Charts 
                </ChartDropTitle>
                { hideFilters
                    ?
                    <ChartDropField
                        align="flex-end"
                    >
                        {filterQuestions.length > 0 && 
                            <AppliedFilters
                                filtersApplied={filterQuestions.length > 0}
                                toggle={filtersAppliedToggle}
                              
                            >   
                                    <div 
                                        className="dropdown-container"  
                                        data-tut="chart-dropdown"
                                    >   
                                        <div 
                                            onClick={() => setFiltersAppliedToggle(prevstate => !prevstate)}  
                                            className="dropdown-container__text">
                                            <span>
                                                Filters control
                                            </span>
                                            <DropdownIcon className="dropdown-icon"/>
                                        </div>
                                        <div 
                                            className="filters-list"
                                            data-tut="chart-dropdown-list"
                                        >
                                            <FilterList/>
                                        </div> 
                                    </div>
                            </AppliedFilters>
                        }
                    </ChartDropField>
                    :
                    <ChartDropField
                        align="stretch"
                    >
                        <QuestionCounterElement
                            width={(chartQuestions.length/5 )* 100}
                            color={path === "hrds" ? colorTeal : colorPurple}
                        />
                        {chartQuestions.length < 5 ? 
                            <Droppable
                                        droppableId={3}
                                    >
                                        {
                                            (provided, snapshot) => (

                                                <MetricsFilterDroppable
                                                    {...provided.droppableProps} 
                                                    ref={provided.innerRef}
                                                    isDraggingOver={snapshot.isDraggingOver}
                                                    justify="flex-end"
                                                    border={borderDroppable}
                                                    color={path === "hrds" ? colorTeal : colorPurple}
                                                    lightColor={path === "hrds" ? colorTealLight : colorPurpleLight}
                                                >
                                                    Drop a question here to analyze its answers!
                                                </MetricsFilterDroppable>
                                            )
                                        }
                                </Droppable>
                            :
                                <LimitMessage>
                                    You have reached the limit of chart questions!
                                </LimitMessage>
                        }
                    </ChartDropField>
                 }
            </ChartDropContainer>
            <ChartContainers
                data-tut="chart-elements"
            >                 
                        { chartDataDisplay &&
                            chartQuestions.map((q,i) => (
                                <ChartElement
                                    key={q.question}
                                >
                                        <ChartTitle 
                                            onClick={() => handleChartTitleClick(q)}
                                            chartTitle
                                        >
                                                {q.question}
                                                <span className="delete-icon">&#10005;</span>
                                        </ChartTitle>
                                        <Chart>
                                            <BarChart
                                                data={chartDataDisplay[i]}
                                                dataCompare={chartDataCompare[i]}
                                            />
                                        </Chart>
                                </ChartElement>
                            ))
                        }
            </ChartContainers>
        </ChartContainer>
     );
}
 
export default ChartElements;